import { useTranslation } from 'react-i18next'
import { StickyNote, X } from 'lucide-react'
import { QuickAdd } from './QuickAdd'
import { ReminderList, type ReminderActions } from './ReminderList'
import type { Reminder, ReminderColor, ReminderDraft } from './types'

interface Props {
  reminders: Reminder[]
  tz: string
  defaultColor: ReminderColor
  actions: ReminderActions & { add: (d: ReminderDraft) => void }
  onClose: () => void
  /** 点实体深链 chip 后关闭本 popover,免得盖住打开的 flyout。 */
  onNavigate?: () => void
  /** 最近一次拉取失败(空状态区分"没有提醒"和"加载失败")。 */
  loadFailed?: boolean
}

export function ReminderPanel({ reminders, tz, defaultColor, actions, onClose, onNavigate, loadFailed }: Props) {
  const { t } = useTranslation('reminders')
  const openCount = reminders.filter((r) => r.status === 'open').length

  return (
    <div data-screen-label="My Reminders panel" style={{
      width: 384, maxHeight: 588, background: 'hsl(var(--popover))', display: 'flex', flexDirection: 'column',
      borderRadius: 14, border: '1px solid hsl(var(--border))', overflow: 'hidden',
      boxShadow: '0 18px 50px -10px rgba(25,20,60,.30), 0 4px 12px rgba(25,20,60,.08)',
      animation: 'rem-pop-down .18s cubic-bezier(.2,.8,.25,1)',
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '13px 16px 11px', borderBottom: '1px solid hsl(var(--border))' }}>
        <StickyNote size={18} />
        <span style={{ fontSize: 14.5, fontWeight: 700, color: 'hsl(var(--foreground))' }}>{t('title')}</span>
        {openCount > 0 && (
          <span style={{ fontSize: 11, fontWeight: 700, color: 'hsl(var(--tone-amber))', background: 'rgba(245, 158, 11, .18)', borderRadius: 99, padding: '2px 8px' }}>{openCount}</span>
        )}
        <div style={{ flex: 1 }} />
        <span style={{ fontSize: 10.5, color: 'hsl(var(--muted-foreground))', fontWeight: 600 }}>{t('privateToYou')}</span>
        <button onClick={onClose} className="rem-icon-btn" title="Close" style={{ opacity: 1 }}><X size={15} /></button>
      </div>
      <QuickAdd tz={tz} defaultColor={defaultColor} onAdd={actions.add} />
      <ReminderList reminders={reminders} tz={tz} actions={actions} onNavigate={onNavigate} loadFailed={loadFailed} />
    </div>
  )
}
